<template>
  <v-btn
  @click="$emit('click')"
  @mouseleave="$emit('mouseleave')"
  :width="width ? width : '100%'"
  :height="height"
  elevation="5"
  :loading="loading"
  :disabled="disabled"
  :style="`background: ${color ? color: '#ffffff'};`"
  :class="`rounded-0 ${smallText ? 'primary-btn-font-small' : 'primary-btn-font-medium'}`">
    {{label}}
    <v-badge
    v-if="badge"
      color="red"
      :content="badge"
      inline
    />
    <mdi-icon
    v-if="icon"
    :src="icon"
    :size="25"/>
  </v-btn>
</template>
<script>
import MdiIcon from '@/components/btns/MdiIcon'
export default {
  components: {
    MdiIcon
  },
  props: {
    label: String,
    width: Number,
    height: Number,
    disabled: Boolean,
    color: String,
    smallText: Boolean,
    loading: Boolean,
    icon: String,
    badge: {
      type: String,
      default: () => {
        return null
      }
    }
  }
}
</script>
<style>
.primary-btn-font-medium.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light {
  color: #fff;
  font-weight: 400;
  font-size: 0.8rem;
  letter-spacing: 0px;
}
.primary-btn-font-small.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light {
  color: #fff;
  font-weight: 400;
  font-size: 0.6rem;
  letter-spacing: 0px;
}

.primary-btn-font-medium.v-btn.v-btn--disabled{
  color: #fff;
  font-weight: 400;
  font-size: 0.8rem;
  letter-spacing: 0px;
  font-family: 'Titillium Web', sans-serif;
}
.primary-btn-font-small.v-btn.v-btn--disabled {
  color: #fff;
  font-weight: 400;
  font-size: 0.6rem;
  letter-spacing: 0px;
  font-family: 'Titillium Web', sans-serif;
}
</style>